import { render, staticRenderFns } from "./upload-area.vue?vue&type=template&id=c7478f9c&scoped=true"
import script from "./upload-area.vue?vue&type=script&lang=js"
export * from "./upload-area.vue?vue&type=script&lang=js"
import style0 from "./upload-area.vue?vue&type=style&index=0&id=c7478f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7478f9c",
  null
  
)

export default component.exports